import React from 'react'
import playstore from '../../assets/play_store.png'
import appstore from '../../assets/app_store.png'
import './AppDownload.css'
import { Link } from 'react-router-dom'
function AppDownload() {
  return (
    <section className='appdownload' id='mobile-app'>
        <div>
            <h4>For Better Experience DownLoad <br/> TomatoApp</h4>
            <div className='store_img'>
            <Link>
                <img src={playstore} alt='playstore'/>
            </Link>
            <Link>
                <img src={appstore} alt='playstore'/>
            </Link>
            </div>
        </div>
    </section>
  )
}

export default AppDownload